/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SkippedCustomerDtoBase
 * auto generated base class for the model SkippedCustomerDtoModel.
 */
export const SkippedCustomerDtoModelBase = ModelBase
  .named('SkippedCustomerDto')
  .props({
    __typename: types.optional(types.literal("SkippedCustomerDto"), "SkippedCustomerDto"),
    customerId: types.union(types.undefined, types.string),
    reason: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SkippedCustomerDtoModelSelector extends QueryBuilder {
  get customerId() { return this.__attr(`customerId`) }
  get reason() { return this.__attr(`reason`) }
}
export function selectFromSkippedCustomerDto() {
  return new SkippedCustomerDtoModelSelector()
}

export const skippedCustomerDtoModelPrimitives = selectFromSkippedCustomerDto().customerId.reason
